// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HouseholdCashflowEntityOptionsQueryVariables = Types.Exact<{
  where: Types.HouseholdWhereInput;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type HouseholdCashflowEntityOptionsQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: { __typename?: 'Household', id: string, displayName: string, possiblePrimaryClients: Array<{ __typename?: 'ClientProfile', id: string, displayName: string, firstName: string, ownedOwnershipStakes?: Array<{ __typename?: 'OwnershipStake', id: string, ownedValue: CurrencyUSD }> | null }>, entities: { __typename?: 'EntityConnection', edges?: Array<{ __typename?: 'EntityEdge', node?: { __typename?: 'Entity', id: string, stage: Types.EntityStage, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'CLTTrust', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'CRTTrust', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'GPBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'GRATTrust', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'ILITTrust', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'IrrevocableTrust', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'JointPersonalAccount', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'LPBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'PrivateFoundation', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'QPRTTrust', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'RevocableTrust', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'SLATTrust', id: string, displayName: string, currentValue: CurrencyUSD } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string, currentValue: CurrencyUSD } } | null } | null> | null } } | null } | null> | null } };

export const Operations = {
  Query: {
    HouseholdCashflowEntityOptions: 'HouseholdCashflowEntityOptions' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const HouseholdCashflowEntityOptionsDocument = gql`
    query HouseholdCashflowEntityOptions($where: HouseholdWhereInput!, $first: Int = 1) {
  households(where: $where, first: $first) {
    edges {
      node {
        id
        displayName
        possiblePrimaryClients {
          id
          displayName
          firstName
          ownedOwnershipStakes {
            id
            ownedValue
          }
        }
        entities {
          edges {
            node {
              id
              stage
              subtype {
                id
                displayName
                currentValue
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useHouseholdCashflowEntityOptionsQuery__
 *
 * To run a query within a React component, call `useHouseholdCashflowEntityOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHouseholdCashflowEntityOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHouseholdCashflowEntityOptionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useHouseholdCashflowEntityOptionsQuery(baseOptions: Apollo.QueryHookOptions<HouseholdCashflowEntityOptionsQuery, HouseholdCashflowEntityOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HouseholdCashflowEntityOptionsQuery, HouseholdCashflowEntityOptionsQueryVariables>(HouseholdCashflowEntityOptionsDocument, withFetchPolicyContext(options));
      }
export function useHouseholdCashflowEntityOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HouseholdCashflowEntityOptionsQuery, HouseholdCashflowEntityOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HouseholdCashflowEntityOptionsQuery, HouseholdCashflowEntityOptionsQueryVariables>(HouseholdCashflowEntityOptionsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useHouseholdCashflowEntityOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HouseholdCashflowEntityOptionsQuery, HouseholdCashflowEntityOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HouseholdCashflowEntityOptionsQuery, HouseholdCashflowEntityOptionsQueryVariables>(HouseholdCashflowEntityOptionsDocument, withFetchPolicyContext(options));
        }
export type HouseholdCashflowEntityOptionsQueryHookResult = ReturnType<typeof useHouseholdCashflowEntityOptionsQuery>;
export type HouseholdCashflowEntityOptionsLazyQueryHookResult = ReturnType<typeof useHouseholdCashflowEntityOptionsLazyQuery>;
export type HouseholdCashflowEntityOptionsSuspenseQueryHookResult = ReturnType<typeof useHouseholdCashflowEntityOptionsSuspenseQuery>;
export type HouseholdCashflowEntityOptionsQueryResult = Apollo.QueryResult<HouseholdCashflowEntityOptionsQuery, HouseholdCashflowEntityOptionsQueryVariables>;